import { render } from "./cp_m.vue?vue&type=template&id=80f12ad8&scoped=true"
import script from "./cp_m.vue?vue&type=script&lang=js"
export * from "./cp_m.vue?vue&type=script&lang=js"

import "./cp_m.vue?vue&type=style&index=0&id=80f12ad8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-80f12ad8"

export default script